import type { ClientCommentChangeRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineCommentEventsApi } from '@/features/api/hooks/grapevine-comment-events/useGrapevineCommentEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useEditComment = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineCommentEventsApi();

  return useApiMutation({
    mutationFn: (commentChangeRequest: ClientCommentChangeRequest) =>
      api.onCommentChangeRequest({
        clientCommentChangeRequest: commentChangeRequest
      }),
    onSuccess: (data) =>
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.COMMENTS, data.comment.postId]
      })
  });
};
